import { SVGProps, Ref, forwardRef } from 'react';

export const DocumentArrowUpOutlinedSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.8 21.2V2.8H13c2.9 0 4.261.507 4.977 1.223S19.2 6.1 19.2 9v12.2zM21 23H3V1h10c6 0 8 2 8 8z"
                    fill="currentColor"
                />
                <path
                    d="M12.9 9.67v7.83h-1.8V9.67l-2.964 2.963-1.272-1.273L12 6.224l5.136 5.136-1.272 1.273z"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
DocumentArrowUpOutlinedSize24Glyph.displayName = 'DocumentArrowUpOutlinedSize24Glyph';
